exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeletedCard__title___2tk20 {\n  margin-bottom: 10px;\n  color: #3f3f3f;\n  text-align: left;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 23.4px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.05);\n  padding: 20px; }\n\n@media (max-width: 768px) {\n  .DeletedCard__title___2tk20 {\n    margin-top: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between; } }\n\n.DeletedCard__deleteButton___3on1s {\n  float: right;\n  cursor: pointer; }\n  .DeletedCard__deleteButton___3on1s i {\n    color: #000000;\n    font-weight: normal; }\n", ""]);

// exports
exports.locals = {
	"title": "DeletedCard__title___2tk20",
	"deleteButton": "DeletedCard__deleteButton___3on1s"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/AdCard/DeletedCard/DeletedCard.scss
// module id = 3919
// module chunks = 6